<template>
  <div class="rc-table-design" ref="rcTableDesign">
    <label class="item-name">{{initComponent.name}}</label>
    <el-table ref="table"
              class="table-class"
              :class="'a_' + initComponent.id"
              :data="tableData"
              height="100%"
              :header-row-style="{height:'40px', cursor:'pointer'}"
              :row-style="{height:'40px', cursor:'pointer',backgroundColor:'#fff'}"
              :header-cell-class-name="displayIcon"
              :header-cell-style="columnColor"
              @cell-click="clickCell"
              @header-click="clickHeader"
              border>
      <el-table-column v-for="(item, index) in columns" :key="index"
                       :label="item.name"
                       :width="140"
                       :render-header="renderHeader"
                       :index="index"
                       header-align="center"
                       :label-class-name="item&&item.properties&&item.properties.required?'requrired':'' "
      >
        <template slot-scope="scope">
          <component
            :is="item.componentType" ref="children"
            :initComponent="item"></component>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog title="列宽设置" center :visible.sync="widthDialog" width="400px" append-to-body>
      <el-form @submit.native.prevent>
        <el-form-item label="列宽:" label-width="80px">
          <el-input v-model="currentColumnWidth"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="widthDialog = false">取 消</el-button>
        <el-button type="primary" @click="setColumnWidth">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import sdk from 'redcatSdk'
import Vue from 'vue'
import _ from 'lodash'
import interact from 'interactjs'
import RcInput from '../input/rc-input.vue'
import RcChildrenInput from '../input/rc-children-input.vue'
import RcCombobox from '../combobox/rc-combobox.vue'
import RcDate from '../date/rc-date.vue'
import RcNumeric from '../numeric/rc-numeric.vue'
import RcCoding from '../coding/rc-coding.vue'
import RcFlowingWater from '../flowing-water/rc-flowing-water.vue'
import RcCurrency from '../currency/rc-currency.vue'
import RcRadio from '../radio/rc-radio.vue'
import RcCheckbox from '../checkbox/rc-checkbox.vue'
import RcUuid from '../uuid/rc-uuid.vue'
import RcPhone from '../phone/rc-phone.vue'
import RcPassword from '../password/rc-password.vue'
import RcFile from '../file/rc-file.vue'
import RcLoginUser from '../login-user/rc-login-user.vue'
import RcIdCard from '../idcard/rc-id-card.vue'
import RcDataSource from '../data-source/rc-data-source.vue'
import RcButton from '../button/rc-button.vue'
import RcSwitch from '../switch/rc-switch.vue'
import RcBigFileUpload from '../big-file-upload/rc-big-file-upload.vue'
import {getProperties} from '@/store/form/componentDefaults.js'

const acceptComponent = ['rc-input', 'rc-combobox', 'rc-date', 'rc-numeric',
  'rc-coding', 'rc-flowing-water', 'rc-currency', 'rc-uuid', 'rc-phone',
  'rc-password', 'rc-file', 'rc-login-user', 'rc-children-input', 'rc-id-card', 'rc-data-source', 'rc-button', 'rc-switch', 'rc-big-file-upload']

export default {
  name: 'rc-table',
  props: ['initComponent', 'position', 'selectId'],
  inject: ['formService', 'componentEventBus', 'componentCount'],
  data () {
    return {
      cols: 20,
      initCols: 0,
      tableData: [{}],
      countColumns: 0,
      widthDialog: false,
      currentColumn: '',
      currentColumnWidth: '',
      resizeObsever: null,
      tableInitSize: {
        width: 0
      }
    }
  },
  components: {
    RcInput,
    RcCombobox,
    RcDate,
    RcCoding,
    RcNumeric,
    RcPhone,
    RcUuid,
    RcCurrency,
    RcRadio,
    RcCheckbox,
    RcPassword,
    RcFlowingWater,
    RcFile,
    RcLoginUser,
    RcChildrenInput,
    RcIdCard,
    RcDataSource,
    RcButton,
    RcSwitch,
    RcBigFileUpload
  },
  created () {
    this.loadComponent()
  },
  beforeDestroy () {
    // 销毁div大小监听
    if (this.resizeObsever) {
      this.resizeObsever.disconnect()
    }
  },
  watch: {
    'initComponent.children' (val) {
      this.initComponent.properties.childrenSort = val.map(n => n.id)
    }
  },
  mounted () {
    let _this = this
    let width = this.$refs.rcTableDesign.clientWidth
    this.cols = this.initCols = Math.ceil(width / 140)
    interact(`.a_${_this.initComponent.id}`).dropzone({
      accept: '.component-template',
      ondragenter: function (event) {
        // 进入当前容器区域时
      },
      ondragleave: function (event) {
        // 离开当前容器区域
      },
      ondrop: _.debounce((event) => {
        let componentType = event.dragEvent.currentTarget.getAttribute('component-type')
        if (componentType === 'rc-upload') {
          componentType = 'rc-file'
        }
        if (acceptComponent.includes(componentType)) {
          if (this.initComponent.children.length >= _this.initCols) {
            _this.cols++
          }
          _this.addComponent({'componentType': `${componentType}`})
        }
      })
    })
    // 监听视窗大小变化来改变表格列数
    this.resizeListener()
  },
  methods: {
    loadComponent () {
      sdk.components && sdk.components.RuntimeArr && sdk.components.RuntimeArr.forEach(n => {
        Vue.component(
          n.name,
          () => Promise.resolve(n.component)
        )
      })
    },
    async addComponent (params) {
      let componentType = params.componentType
      let component = getProperties(componentType)
      if (this.componentCount[componentType]) {
        this.componentCount[componentType] = this.componentCount[componentType] + 1
      } else {
        this.componentCount[componentType] = 1
      }
      if (componentType === 'rc-file') {
        component.defaults.properties.listType = 'tableFile'
      }
      component.defaults.properties.count = this.componentCount[componentType]
      component.defaults.name = component.defaults.name + this.componentCount[componentType]
      let pinyin = await this.formService.getPinyinByHanzi(component.defaults.name)
      component.defaults.pinyinName = pinyin.pinyinName
      component.defaults.pinyinFirstChar = pinyin.pinyinFirstChar
      let cm = this.formService.createComponent(component, this.initComponent)
      let scroll = this.$refs.rcTableDesign.querySelector('.table-class').querySelector('.el-table__body-wrapper')
      this.$nextTick(() => {
        let table = this.formService.schema.getTable(cm.archive.tableId)
        // 表格不需要改列的值
        if (cm.componentType === 'rc-table') {
          table.pinyinName = pinyin.pinyinName
          table.pinyinFirstChar = pinyin.pinyinFirstChar
        } else {
          if (table && table.columns) {
            let c = table.columns.find(c => c.id === cm.archive.columnId)
            c.pinyinName = pinyin.pinyinName
            c.pinyinFirstChar = pinyin.pinyinFirstChar
          }
        }
        this.$refs.table.doLayout()
        this.countColumns = this.$refs.children.length
        let scrollWidth = scroll.scrollWidth
        if (scrollWidth > 140 * this.initCols) {
          scroll.scrollLeft = scrollWidth
        }
      })
    },
    resizeListener () {
      const target = this.$refs.table.$el
      // 监听元素大小变化
      this.resizeObsever = new ResizeObserver(this.$_.debounce(entries => {
        for (let entry of entries) {
          if (!this.tableInitSize.width) {
            this.tableInitSize.width = entry.contentRect.width
          }
          if (this.tableInitSize.width && this.tableInitSize.width < entry.contentRect.width) {
            let cols = Math.ceil(entry.contentRect.width / 140)
            if (this.columns.length < cols) {
              this.cols = cols
              this.resizeObsever.observe(target)
            }
          }
        }
      }, 100))
      this.resizeObsever.observe(target)
    },
    clickCell (row, column, cell, event) {
      this.openAttr(column.index)
      event.stopPropagation()
    },
    clickHeader (column, event) {
      this.openAttr(column.index)
      event.stopPropagation()
    },
    openAttr (index) {
      let currentComponent = this.initComponent.children[index]
      if (currentComponent) {
        this.componentEventBus.$emit('changeLeftPanel', {state: 'ComponentAttr', id: currentComponent.id})
      }
    },
    renderHeader (h, {column, $index}) {
      let _this = this
      let myColumnName = ''
      let disabled = true
      if (!column.label) {
        return null
      } else if (column.label.length > 4) {
        myColumnName = column.label.slice(0, 3) + '...'
        disabled = false
      } else {
        myColumnName = column.label
      }
      let result = [
        h('i',
          {
            'class': 'el-icon-caret-left component-title',
            on: {
              click: function () {
                _this.moveChildren($index, 'left')
              }
            }
          }),
        h('el-tooltip', {attrs: {content: column.label, placement: 'top-start', disabled: disabled}}, [
          h('label',
            {
              'class': 'component-title rc-table-design-label',
              on: {
                dblclick: function (event) {
                  event.preventDefault()
                  _this.currentColumn = _this.columns[$index].archive.columnId

                  if (_this.initComponent.properties.widths.find(item => item.columnId === _this.currentColumn)) {
                    _this.currentColumnWidth = _this.initComponent.properties.widths.find(item => item.columnId === _this.currentColumn).columnWidth
                  } else {
                    _this.currentColumnWidth = 140
                  }
                  _this.widthDialog = true
                }
              }
            }, myColumnName)
        ]),
        h('i',
          {
            'class': 'el-icon-caret-right component-title',
            on: {
              click: function () {
                _this.moveChildren($index, 'right')
              }
            }
          })
      ]
      let component = this.initComponent.children[$index]
      if (!(component && component.properties.noDelete)) {
        result.push(h('i',
          {
            'class': 'el-icon-close display-icon-close',
            on: {
              click: function () {
                _this.deleteChildren($index)
              }
            }
          }))
      }
      return result
    },
    // 左右移动图标显示
    displayIcon ({row, column}) {
      if (column.index === this.countColumns - 1) {
        return 'last-right-icon'
      }
      return 'display-icon'
    },
    // 背景颜色
    columnColor ({row, column, rowIndex, columnIndex}) {
      if (this.initComponent.children[columnIndex] && this.initComponent.children[columnIndex].id === this.selectId) {
        return 'backgroundColor: #F1F8FE'
      }
    },
    moveChildren (index, type) {
      event.stopPropagation()
      if (index === 0 && type === 'left') {
        return null
      } else if (index === this.$refs.children.length - 1 && type === 'right') {
        return null
      } else {
        // 左右移动列,滚动条左移或右移一个单位
        let scroll = this.$refs.rcTableDesign.querySelector('.table-class').querySelector('.el-table__body-wrapper')
        if (type === 'left') {
          if (scroll.scrollWidth > 140 * this.initCols) {
            this.$refs.rcTableDesign.querySelector('.table-class').querySelector('.el-table__body-wrapper').scrollLeft = scroll.scrollLeft - 140
          }
        } else {
          if (scroll.scrollWidth > 140 * this.initCols) {
            this.$refs.rcTableDesign.querySelector('.table-class').querySelector('.el-table__body-wrapper').scrollLeft = scroll.scrollLeft + 140
          }
        }
        let children = this.initComponent.children
        let before
        let after
        if (type === 'right') {
          before = index
          after = index + 1
        } else {
          before = index - 1
          after = index
        }
        children.splice(after, 1, ...children.splice(before, 1, children[after]))
      }
    },
    deleteChildren (index) {
      let component = this.initComponent.children[index]
      // 首先检查要删除的控件是不是有自定义的删除前置事件, 如果有的话, 优先执行前置事件
      let currenComponent = this.$refs.children.find(m => m.component === component)
      if (currenComponent && currenComponent.remove) {
        currenComponent.remove()
      }
      this.componentEventBus.$emit('changeLeftPanel', {state: 'ComponentList', id: component.id})
      this.formService.removeComponent(component)
      this.$nextTick(() => {
        this.countColumns = this.$refs.children.length
      })
      if (this.cols > this.initCols) {
        this.cols--
      }
    },
    setColumnWidth () {
      let myColumn = {}
      let isExistColumn = {}
      myColumn.columnId = this.currentColumn
      isExistColumn = this.initComponent.properties.widths.find(item => item.columnId === myColumn.columnId)
      if (isExistColumn) {
        isExistColumn.columnWidth = this.currentColumnWidth
      } else {
        myColumn.columnWidth = this.currentColumnWidth
        this.initComponent.properties.widths.push(myColumn)
      }
      this.widthDialog = false
    }
  },
  computed: {
    // 控制表格列数
    columns () {
      let childrenComponent = []
      let numberOfColumns = this.cols
      for (let i = 0; i < numberOfColumns; i++) {
        childrenComponent.push({})
      }
      this.initComponent.children.forEach((m, index) => {
        this.$set(childrenComponent, index, m)
      })

      return childrenComponent
    }
  }

}
</script>

<style lang="scss">
  .rc-table-design {
    height: calc(100% - 45px);
    .column-color{
      background-color: #EBF5FF;
    }
    .el-table.table-class {
      width: 100%;
      overflow: auto;
      height: 100%;
      margin-top: 8px;
      th {
        >.cell {
          color: #181818;
        }
      }
      .el-table__body-wrapper {
        .el-table__body {
          .el-table__row {
            .cell {
              >div {
                .item-name {
                  display: none;
                }
              }
              .content {
                text-align: center;
              }
            }
          }
        }
      }
      .el-table__row{
        height: 40px;
        td{
          padding: 0;
        }
      }
      .el-table--enable-row-hover .el-table__body tr:hover > td {
        /* 重写 hover 样式, 获取焦点是不变色 */
        background-color: #fff;
      }
      label.component-title {
        font-size: 14px;
        font-weight: 100;
        padding-left: 5px;
      }
      .requrired .rc-table-design-label {
        position: relative;
          &::before {
            content:'*';
            position: absolute;
            right: -6px;
            top: -6px;
            color:red;
        }
      }
      i.component-title {
        visibility: hidden;
        padding-left: 10px;
        padding-right: 5px;
      }
      .display-icon-close{
        visibility: hidden;
      }
      .display-icon,.last-right-icon{
        &:hover{
          background-color: #F7F9FB;
        }
        .cell{
          padding: 0;
          &:hover {
            i {
              visibility: visible;
              &:hover {
                color: #66b1ff;
              }
            }
            i.display-icon-close:hover {
              color: #FF2828;
            }
          }
        }
      }
      .last-right-icon{
        .cell{
          i.el-icon-caret-right{
            color: #CCCDCE;
            &:hover{
              color: #CCCDCE;
            }
          }
        }
      }
      thead.has-gutter{
        tr{
          th:first-of-type{
            .cell i.el-icon-caret-left{
              color:#CCCDCE;
            }
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/form/components/table/rc-table.vue